import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentReturn() {
  const { outcome } = useParams(); // "success" | "cancel"
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState(outcome === "cancel" ? "cancelled" : "checking");
  const proposalId = params.get("proposal");

  useEffect(() => {
    if (outcome !== "success") return;
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const res = await api.paymentStatus(sid);
        if (res.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(res.payment_status)) { setState("error"); return; }
      } catch { /* keep trying */ }
      if (tries >= 6) { setState("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [outcome, params]);

  const icon = { checking: <Loader2 size={44} className="text-primary-400 animate-spin" />, paid: <CheckCircle2 size={44} className="text-green-400" />, cancelled: <XCircle size={44} className="text-orange-400" />, error: <XCircle size={44} className="text-red-400" />, pending: <Loader2 size={44} className="text-primary-400" /> }[state];
  const title = { checking: "Confirming your payment…", paid: "Payment successful!", cancelled: "Payment cancelled", error: "Payment could not be confirmed", pending: "Still processing…" }[state];
  const msg = {
    checking: "Hang tight while we confirm with Stripe.",
    paid: "You're all set. Your subscription / payment is active.",
    cancelled: "No charge was made. You can try again anytime.",
    error: "If you were charged, it will reflect shortly. Please contact support if this persists.",
    pending: "Your payment is taking a moment. It will update automatically once confirmed.",
  }[state];

  return (
    <div className="min-h-screen clean-bg flex items-center justify-center p-6 text-center" data-testid="payment-return">
      <div className="glass-panel rounded-2xl p-10 max-w-md">
        <div className="flex justify-center mb-5">{icon}</div>
        <h1 className="text-xl font-bold text-white mb-2" data-testid="payment-return-title">{title}</h1>
        <p className="text-sm text-zinc-400 mb-7">{msg}</p>
        {proposalId ? (
          <button onClick={() => navigate(`/proposal/${proposalId}`)} className="px-6 py-3 bg-primary-600 text-white rounded-xl font-bold hover:bg-primary-500 transition" data-testid="payment-return-proposal-btn">Back to Proposal</button>
        ) : (
          <button onClick={() => navigate("/app/generator")} className="px-6 py-3 bg-primary-600 text-white rounded-xl font-bold hover:bg-primary-500 transition">Go to Generator</button>
        )}
      </div>
    </div>
  );
}
